export default __webpack_public_path__ + "static/media/trackers-background.2b5246bb.svg";